export default "__VITE_ASSET__BPAg6mie__"